import { createContext, useContext, useState, useEffect } from "react";
import { useFetch } from "../../hooks/useFetch";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import useUserLocation from "../../hooks/useUserLocation";
import MantineTheme from "../../theme/mantine";
import { cssVars } from "../../theme/css-vars";
import axios from "axios";

const AppContext = createContext();

export const useAppContext = () => {
   return useContext(AppContext);
};

export const AppProvider = ({ children }) => {
   const { width } = useWindowDimensions();
   const isMobile = width <= 768;
   const [paymentData, setPaymentData] = useState(null);
   const [isReady, setIsReady] = useState(false);
   const [jsonTexts, setJsonTexts] = useState({});
   const [jsonMedia, setJsonMedia] = useState({});
   const [jsonColors, setJsonColors] = useState({});
   const [jsonFeatures, setJsonFeatures] = useState({});
   const [jsonFonts, setJsonFonts] = useState({});
   const [jsonBranding, setJsonBranding] = useState({});
   const [theme, setTheme] = useState({});

   // header content
   const [specialtiesInfo, setSpecialtiesInfo] = useState({
      data: null,
      isLoading: true,
      error: null
   })
   const [openSource, setOpenSource] = useState({
      data: null,
      isLoading: true,
      error: null
   })


   // getting user location
   const { getUserLocation, isUSD, permissionModal, setPermissionModal } =
      useUserLocation();

   const officialUSDResponse = useFetch(
      `https://dolarapi.com/v1/dolares/oficial`
   );
   const officialUSDValue = officialUSDResponse?.data?.venta || null;
   
   
   // JSON uploading
   useEffect(() => {
      axios.defaults.headers.common["db"] = process.env.REACT_APP_CUSTOMER_NAME;

      const fetchConfig = async () => {
         try {
            
            const response = await axios.get(
               `${process.env.REACT_APP_BACKEND_SERVER}/info/configJson`
            );
            const config = response.data.CLIENT_FRONT;

            setJsonBranding(config.branding);
            setJsonTexts(config.texts);
            setJsonMedia(config.media);
            setJsonColors(config.colors);
            setJsonFeatures(config.features);
            setJsonFonts(config.typography);
            cssVars({ root, config });

            const theme = MantineTheme(config.mantine);
            setTheme(theme);
         } catch (error) {
            console.error("Error fetching FAQs data:", error);
         } finally {
            setIsReady(true);
         }
      };

      const getMegaMenuInfo = async () => {
         try {
            const specialties_response = await axios.get(`${process.env.REACT_APP_BACKEND_SERVER}/info/specialties/`)
            setSpecialtiesInfo(specialties_response)

            const openSource_response = await axios.get(`${process.env.REACT_APP_BACKEND_SERVER}/info/openSource/`)
            setOpenSource(openSource_response)
            
         } catch (error) {
            console.log({error})
         } finally{
            setSpecialtiesInfo(prevState => ({
               ...prevState, 
               isLoading: false
            }))
            setOpenSource(prevState => ({
               ...prevState, 
               isLoading: false
            }))
         }
      }

      // set css vars
      const root = document.documentElement;
      fetchConfig();
      getMegaMenuInfo()
   }, []);

   return (
      <AppContext.Provider
         value={{
            theme,
            getUserLocation,
            setPaymentData,
            setPermissionModal,
            specialtiesInfo,
            openSource,
            paymentData,
            permissionModal,
            width,
            isMobile,
            isUSD,
            officialUSDValue,
            jsonBranding,
            jsonTexts,
            jsonMedia,
            jsonColors,
            jsonFeatures,
            jsonFonts,
            isReady,
         }}
      >
         {children}
      </AppContext.Provider>
   );
};
